import React, {forwardRef, useId} from 'react'
import {chakra} from '@chakra-ui/react3'
import PropTypes from 'prop-types'

import _3dRotateFilledSymbol from '../../assets/svg/3d-rotate-filled.svg'
import _3dRotateSymbol from '../../assets/svg/3d-rotate.svg'
import AddSymbol from '../../assets/svg/add.svg'
import ArrowDownSymbol from '../../assets/svg/arrow-down.svg'
import ArrowLeftSymbol from '../../assets/svg/arrow-left-leap.svg'
import ArrowReloadHorizontalSymbol from '../../assets/svg/arrow-reload-horizontal.svg'
import ArrowRightSymbol from '../../assets/svg/arrow-right-leap.svg'
import ArrowTurnBackwardSymbol from '../../assets/svg/arrow-turn-backward.svg'
import ArrowUpSymbol from '../../assets/svg/arrow-up.svg'
import BookmarkAddFilledSymbol from '../../assets/svg/bookmark-add-filled.svg'
import BookmarkAddSymbol from '../../assets/svg/bookmark-add.svg'
import BookmarkFilledSymbol from '../../assets/svg/bookmark-filled.svg'
import BookmarkSymbol from '../../assets/svg/bookmark.svg'
import BookOpenSymbol from '../../assets/svg/book-open.svg'
import BubbleChatSymbol from '../../assets/svg/bubble-chat.svg'
import BubbleChatQuestionSymbol from '../../assets/svg/bubble-chat-question.svg'
import CalendarFilledSymbol from '../../assets/svg/calendar-filled.svg'
import CalendarSymbol from '../../assets/svg/calendar.svg'
import CancelSymbol from '../../assets/svg/cancel.svg'
import CheckSymbol from '../../assets/svg/check.svg'
import CheckmarkBadgeFilledSymbol from '../../assets/svg/checkmark-badge-filled.svg'
import CheckmarkBadgeSymbol from '../../assets/svg/checkmark-badge.svg'
import CheckmarkCircleFilledSymbol from '../../assets/svg/checkmark-circle-filled.svg'
import CheckmarkCircleSymbol from '../../assets/svg/checkmark-circle.svg'
import ChevronDownSymbol from '../../assets/svg/chevron-down-leap.svg'
import ChevronLeftSymbol from '../../assets/svg/chevron-left-leap.svg'
import ChevronRightSymbol from '../../assets/svg/chevron-right-leap.svg'
import ChevronUpSymbol from '../../assets/svg/chevron-up-leap.svg'
import ClockFilledSymbol from '../../assets/svg/clock-filled.svg'
import ClockSymbol from '../../assets/svg/clock.svg'
import CopyFilledSymbol from '../../assets/svg/copy-filled.svg'
import CopySymbol from '../../assets/svg/copy.svg'
import CreditCardSymbol from '../../assets/svg/credit-card.svg'
import DashboardSquareFilledSymbol from '../../assets/svg/dashboard-square-filled.svg'
import DashboardSquareSymbol from '../../assets/svg/dashboard-square.svg'
import DeleteFilledSymbol from '../../assets/svg/delete-filled.svg'
import DeleteSymbol from '../../assets/svg/delete-leap.svg'
import DocumentValidationFilledSymbol from '../../assets/svg/document-validation-filled.svg'
import DocumentValidationSymbol from '../../assets/svg/document-validation.svg'
import DownloadSymbol from '../../assets/svg/download.svg'
import FavoriteFilledSymbol from '../../assets/svg/favorite-filled.svg'
import FavoriteSymbol from '../../assets/svg/favorite.svg'
import FilterHorizontalFilledSymbol from '../../assets/svg/filter-horizontal-filled.svg'
import FilterHorizontalSymbol from '../../assets/svg/filter-horizontal.svg'
import GlobeSymbol from '../../assets/svg/globe.svg'
import GpsSymbol from '../../assets/svg/gps.svg'
import HeadsetSymbol from '../../assets/svg/headset.svg'
import HourglassFilledSymbol from '../../assets/svg/hourglass-filled.svg'
import HourglassSymbol from '../../assets/svg/hourglass.svg'
import LocationFilledSymbol from '../../assets/svg/location-filled.svg'
import LocationSymbol from '../../assets/svg/location-leap.svg'
import LoginSymbol from '../../assets/svg/login.svg'
import LogoutSymbol from '../../assets/svg/logout-leap.svg'
import PauseSymbol from '../../assets/svg/pause.svg'
import PenFilledSymbol from '../../assets/svg/pen-filled.svg'
import PenSymbol from '../../assets/svg/pen.svg'
import PlaySymbol from '../../assets/svg/play-leap.svg'
import RemoveSymbol from '../../assets/svg/remove.svg'
import Rotate360Symbol from '../../assets/svg/rotate360.svg'
import SearchAddSymbol from '../../assets/svg/search-add.svg'
import SearchMinusSymbol from '../../assets/svg/search-minus.svg'
import SearchSymbol from '../../assets/svg/search.svg'
import SecurityValidationFilledSymbol from '../../assets/svg/security-validation-filled.svg'
import SecurityValidationSymbol from '../../assets/svg/security-validation.svg'
import SettingsFilledSymbol from '../../assets/svg/settings-filled.svg'
import SettingsSymbol from '../../assets/svg/settings.svg'
import SortByDownSymbol from '../../assets/svg/sort-by-down.svg'
import SortByUpSymbol from '../../assets/svg/sort-by-up.svg'
import StarFilledSymbol from '../../assets/svg/star-filled.svg'
import StarSymbol from '../../assets/svg/star.svg'
import StopWatchFilledSymbol from '../../assets/svg/stop-watch-filled.svg'
import StopWatchSymbol from '../../assets/svg/stop-watch.svg'
import TokenCircleFilledSymbol from '../../assets/svg/token-circle-filled.svg'
import TokenCircleSymbol from '../../assets/svg/token-circle.svg'
import TrippTrappSymbol from '../../assets/svg/tripp-trapp.svg'
import UserFilledSymbol from '../../assets/svg/user-filled.svg'
import UserSymbol from '../../assets/svg/user-leap.svg'
import VideoSymbol from '../../assets/svg/video.svg'

_3dRotateFilledSymbol.viewBox = _3dRotateFilledSymbol.viewBox || '0 0 22 22'
_3dRotateSymbol.viewBox = _3dRotateSymbol.viewBox || '0 0 22 22'
AddSymbol.viewBox = AddSymbol.viewBox || '0 0 18 18'
ArrowDownSymbol.viewBox = ArrowDownSymbol.viewBox || '0 0 24 24'
ArrowLeftSymbol.viewBox = ArrowLeftSymbol.viewBox || '0 0 24 24'
ArrowReloadHorizontalSymbol.viewBox = ArrowReloadHorizontalSymbol.viewBox || '0 0 24 24'
ArrowRightSymbol.viewBox = ArrowRightSymbol.viewBox || '0 0 24 24'
ArrowTurnBackwardSymbol.viewBox = ArrowTurnBackwardSymbol.viewBox || '0 0 24 24'
ArrowUpSymbol.viewBox = ArrowUpSymbol.viewBox || '0 0 12 18'
BookmarkAddFilledSymbol.viewBox = BookmarkAddFilledSymbol.viewBox || '0 0 20 22'
BookmarkAddSymbol.viewBox = BookmarkAddSymbol.viewBox || '0 0 20 22'
BookmarkFilledSymbol.viewBox = BookmarkFilledSymbol.viewBox || '0 0 18 22'
BookmarkSymbol.viewBox = BookmarkSymbol.viewBox || '0 0 18 22'
BookOpenSymbol.viewBox = BookOpenSymbol.viewBox || '0 0 21 20'
BubbleChatSymbol.viewBox = BubbleChatSymbol.viewBox || '0 0 21 21'
BubbleChatQuestionSymbol.viewBox = BubbleChatQuestionSymbol.viewBox || '0 0 21 21'
CalendarFilledSymbol.viewBox = CalendarFilledSymbol.viewBox || '0 0 22 22'
CalendarSymbol.viewBox = CalendarSymbol.viewBox || '0 0 20 22'
CancelSymbol.viewBox = CancelSymbol.viewBox || '0 0 16 16'
CheckSymbol.viewBox = CheckSymbol.viewBox || '0 0 17 14'
CheckmarkBadgeFilledSymbol.viewBox = CheckmarkBadgeFilledSymbol.viewBox || '0 0 22 22'
CheckmarkBadgeSymbol.viewBox = CheckmarkBadgeSymbol.viewBox || '0 0 22 22'
CheckmarkCircleFilledSymbol.viewBox = CheckmarkCircleFilledSymbol.viewBox || '0 0 22 22'
CheckmarkCircleSymbol.viewBox = CheckmarkCircleSymbol.viewBox || '0 0 22 22'
ChevronDownSymbol.viewBox = ChevronDownSymbol.viewBox || '0 0 24 24'
ChevronLeftSymbol.viewBox = ChevronLeftSymbol.viewBox || '0 0 24 24'
ChevronRightSymbol.viewBox = ChevronRightSymbol.viewBox || '0 0 24 24'
ChevronUpSymbol.viewBox = ChevronUpSymbol.viewBox || '0 0 24 24'
ClockFilledSymbol.viewBox = ClockFilledSymbol.viewBox || '0 0 22 22'
ClockSymbol.viewBox = ClockSymbol.viewBox || '0 0 22 22'
CopyFilledSymbol.viewBox = CopyFilledSymbol.viewBox || '0 0 22 22'
CopySymbol.viewBox = CopySymbol.viewBox || '0 0 22 22'
CreditCardSymbol.viewBox = CreditCardSymbol.viewBox || '0 0 21 17'
DashboardSquareFilledSymbol.viewBox = DashboardSquareFilledSymbol.viewBox || '0 0 22 22'
DashboardSquareSymbol.viewBox = DashboardSquareSymbol.viewBox || '0 0 22 22'
DeleteFilledSymbol.viewBox = DeleteFilledSymbol.viewBox || '0 0 20 22'
DeleteSymbol.viewBox = DeleteSymbol.viewBox || '0 0 20 22'
DocumentValidationFilledSymbol.viewBox = DocumentValidationFilledSymbol.viewBox || '0 0 22 22'
DocumentValidationSymbol.viewBox = DocumentValidationSymbol.viewBox || '0 0 22 22'
DownloadSymbol.viewBox = DownloadSymbol.viewBox || '0 0 18 18'
FavoriteFilledSymbol.viewBox = FavoriteFilledSymbol.viewBox || '0 0 22 20'
FavoriteSymbol.viewBox = FavoriteSymbol.viewBox || '0 0 22 20'
FilterHorizontalFilledSymbol.viewBox = FilterHorizontalFilledSymbol.viewBox || '0 0 24 24'
FilterHorizontalSymbol.viewBox = FilterHorizontalSymbol.viewBox || '0 0 24 24'
GlobeSymbol.viewBox = GlobeSymbol.viewBox || '0 0 22 22'
GpsSymbol.viewBox = GpsSymbol.viewBox || '0 0 24 24'
HeadsetSymbol.viewBox = HeadsetSymbol.viewBox || '0 0 19 21'
HourglassFilledSymbol.viewBox = HourglassFilledSymbol.viewBox || '0 0 18 22'
HourglassSymbol.viewBox = HourglassSymbol.viewBox || '0 0 18 22'
LocationFilledSymbol.viewBox = LocationFilledSymbol.viewBox || '0 0 20 22'
LocationSymbol.viewBox = LocationSymbol.viewBox || '0 0 20 22'
LoginSymbol.viewBox = LoginSymbol.viewBox || '0 0 20 19'
LogoutSymbol.viewBox = LogoutSymbol.viewBox || '0 0 20 19'
PauseSymbol.viewBox = PauseSymbol.viewBox || '0 0 24 24'
PenFilledSymbol.viewBox = PenFilledSymbol.viewBox || '0 0 20 20'
PenSymbol.viewBox = PenSymbol.viewBox || '0 0 18 18'
PlaySymbol.viewBox = PlaySymbol.viewBox || '0 0 24 24'
RemoveSymbol.viewBox = RemoveSymbol.viewBox || '0 0 18 2'
Rotate360Symbol.viewBox = Rotate360Symbol.viewBox || '0 0 22 20'
SearchAddSymbol.viewBox = SearchAddSymbol.viewBox || '0 0 24 24'
SearchMinusSymbol.viewBox = SearchMinusSymbol.viewBox || '0 0 24 24'
SearchSymbol.viewBox = SearchSymbol.viewBox || '0 0 20 20'
SecurityValidationFilledSymbol.viewBox = SecurityValidationFilledSymbol.viewBox || '0 0 20 22'
SecurityValidationSymbol.viewBox = SecurityValidationSymbol.viewBox || '0 0 20 22'
SettingsFilledSymbol.viewBox = SettingsFilledSymbol.viewBox || '0 0 22 22'
SettingsSymbol.viewBox = SettingsSymbol.viewBox || '0 0 24 24'
SortByDownSymbol.viewBox = SortByDownSymbol.viewBox || '0 0 6 13'
SortByUpSymbol.viewBox = SortByUpSymbol.viewBox || '0 0 24 24'
StarFilledSymbol.viewBox = StarFilledSymbol.viewBox || '0 0 22 22'
StarSymbol.viewBox = StarSymbol.viewBox || '0 0 20 20'
StopWatchFilledSymbol.viewBox = StopWatchFilledSymbol.viewBox || '0 0 20 22'
StopWatchSymbol.viewBox = StopWatchSymbol.viewBox || '0 0 20 22'
TokenCircleFilledSymbol.viewBox = TokenCircleFilledSymbol.viewBox || '0 0 22 22'
TokenCircleSymbol.viewBox = TokenCircleSymbol.viewBox || '0 0 22 22'
TrippTrappSymbol.viewBox = TrippTrappSymbol.viewBox || '0 0 24 24'
UserFilledSymbol.viewBox = UserFilledSymbol.viewBox || '0 0 24 24'
UserSymbol.viewBox = UserSymbol.viewBox || '0 0 24 24'
VideoSymbol.viewBox = VideoSymbol.viewBox || '0 0 21 17'

const Svg = chakra('svg', {})

function makeSpriteIcon(name, extras = {}) {
    const {viewBox = '0 0 24 24', role = 'img'} = extras

    const SpriteIcon = forwardRef((props, ref) => {
        const {'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, ...rest} = props
        const titleId = useId()

        const a11y = ariaLabel
            ? {'aria-labelledby': titleId}
            : ariaLabelledby
            ? {'aria-labelledby': ariaLabelledby}
            : {'aria-hidden': true}

        return (
            <Svg ref={ref} viewBox={viewBox} role={role} focusable="false" {...a11y} {...rest}>
                {ariaLabel && <title id={titleId}>{ariaLabel}</title>}
                <use href={`#leap-${name}`} xlinkHref={`#leap-${name}`} />
            </Svg>
        )
    })

    SpriteIcon.displayName = `${name
        .replace(/(^|[-_ ])\w/g, (m) => m.toUpperCase())
        .replace(/[-_ ]/g, '')}Icon`

    SpriteIcon.propTypes = {
        'aria-label': PropTypes.string,
        'aria-labelledby': PropTypes.string
    }

    return SpriteIcon
}

// Exports (alphabetisch)
export const _3dRotateFilledIcon = makeSpriteIcon('3d-rotate-filled', {
    viewBox: _3dRotateFilledSymbol.viewBox
})
export const _3dRotateIcon = makeSpriteIcon('3d-rotate', {viewBox: _3dRotateSymbol.viewBox})
export const AddIcon = makeSpriteIcon('add', {viewBox: AddSymbol.viewBox})
export const ArrowDownIcon = makeSpriteIcon('arrow-down', {viewBox: ArrowDownSymbol.viewBox})
export const ArrowLeftIcon = makeSpriteIcon('arrow-left-leap', {viewBox: ArrowLeftSymbol.viewBox})
export const ArrowReloadHorizontalIcon = makeSpriteIcon('arrow-reload-horizontal', {
    viewBox: ArrowReloadHorizontalSymbol.viewBox
})
export const ArrowRightIcon = makeSpriteIcon('arrow-right-leap', {
    viewBox: ArrowRightSymbol.viewBox
})
export const ArrowTurnBackwardIcon = makeSpriteIcon('arrow-turn-backward', {
    viewBox: ArrowTurnBackwardSymbol.viewBox
})
export const ArrowUpIcon = makeSpriteIcon('arrow-up', {viewBox: ArrowUpSymbol.viewBox})
export const BookmarkAddFilledIcon = makeSpriteIcon('bookmark-add-filled', {
    viewBox: BookmarkAddFilledSymbol.viewBox
})
export const BookmarkAddIcon = makeSpriteIcon('bookmark-add', {viewBox: BookmarkAddSymbol.viewBox})
export const BookmarkFilledIcon = makeSpriteIcon('bookmark-filled', {
    viewBox: BookmarkFilledSymbol.viewBox
})
export const BookmarkIcon = makeSpriteIcon('bookmark', {viewBox: BookmarkSymbol.viewBox})
export const BookOpenIcon = makeSpriteIcon('book-open', {viewBox: BookOpenSymbol.viewBox})
export const BubbleChatIcon = makeSpriteIcon('bubble-chat', {viewBox: BubbleChatSymbol.viewBox})
export const BubbleChatQuestionIcon = makeSpriteIcon('bubble-chat-question', {
    viewBox: BubbleChatQuestionSymbol.viewBox
})
export const CalendarFilledIcon = makeSpriteIcon('calendar-filled', {
    viewBox: CalendarFilledSymbol.viewBox
})
export const CalendarIcon = makeSpriteIcon('calendar', {viewBox: CalendarSymbol.viewBox})
export const CancelIcon = makeSpriteIcon('cancel', {viewBox: CancelSymbol.viewBox})
export const CheckIcon = makeSpriteIcon('check', {viewBox: CheckSymbol.viewBox})
export const CheckmarkBadgeFilledIcon = makeSpriteIcon('checkmark-badge-filled', {
    viewBox: CheckmarkBadgeFilledSymbol.viewBox
})
export const CheckmarkBadgeIcon = makeSpriteIcon('checkmark-badge', {
    viewBox: CheckmarkBadgeSymbol.viewBox
})
export const CheckmarkCircleFilledIcon = makeSpriteIcon('checkmark-circle-filled', {
    viewBox: CheckmarkCircleFilledSymbol.viewBox
})
export const CheckmarkCircleIcon = makeSpriteIcon('checkmark-circle', {
    viewBox: CheckmarkCircleSymbol.viewBox
})
export const ChevronDownIcon = makeSpriteIcon('chevron-down-leap', {
    viewBox: ChevronDownSymbol.viewBox
})
export const ChevronLeftIcon = makeSpriteIcon('chevron-left-leap', {
    viewBox: ChevronLeftSymbol.viewBox
})
export const ChevronRightIcon = makeSpriteIcon('chevron-right-leap', {
    viewBox: ChevronRightSymbol.viewBox
})
export const ChevronUpIcon = makeSpriteIcon('chevron-up-leap', {viewBox: ChevronUpSymbol.viewBox})
export const ClockFilledIcon = makeSpriteIcon('clock-filled', {viewBox: ClockFilledSymbol.viewBox})
export const ClockIcon = makeSpriteIcon('clock', {viewBox: ClockSymbol.viewBox})
export const CopyFilledIcon = makeSpriteIcon('copy-filled', {viewBox: CopyFilledSymbol.viewBox})
export const CopyIcon = makeSpriteIcon('copy', {viewBox: CopySymbol.viewBox})
export const CreditCardIcon = makeSpriteIcon('credit-card', {viewBox: CreditCardSymbol.viewBox})
export const DashboardSquareFilledIcon = makeSpriteIcon('dashboard-square-filled', {
    viewBox: DashboardSquareFilledSymbol.viewBox
})
export const DashboardSquareIcon = makeSpriteIcon('dashboard-square', {
    viewBox: DashboardSquareSymbol.viewBox
})
export const DeleteFilledIcon = makeSpriteIcon('delete-filled', {
    viewBox: DeleteFilledSymbol.viewBox
})
export const DeleteIcon = makeSpriteIcon('delete-leap', {viewBox: DeleteSymbol.viewBox})
export const DocumentValidationFilledIcon = makeSpriteIcon('document-validation-filled', {
    viewBox: DocumentValidationFilledSymbol.viewBox
})
export const DocumentValidationIcon = makeSpriteIcon('document-validation', {
    viewBox: DocumentValidationSymbol.viewBox
})
export const DownloadIcon = makeSpriteIcon('download', {viewBox: DownloadSymbol.viewBox})
export const FavoriteFilledIcon = makeSpriteIcon('favorite-filled', {
    viewBox: FavoriteFilledSymbol.viewBox
})
export const FavoriteIcon = makeSpriteIcon('favorite', {viewBox: FavoriteSymbol.viewBox})
export const FilterHorizontalFilledIcon = makeSpriteIcon('filter-horizontal-filled', {
    viewBox: FilterHorizontalFilledSymbol.viewBox
})
export const FilterHorizontalIcon = makeSpriteIcon('filter-horizontal', {
    viewBox: FilterHorizontalSymbol.viewBox
})
export const GlobeIcon = makeSpriteIcon('globe', {viewBox: GlobeSymbol.viewBox})
export const GpsIcon = makeSpriteIcon('gps', {viewBox: GpsSymbol.viewBox})
export const HeadsetIcon = makeSpriteIcon('headset', {viewBox: HeadsetSymbol.viewBox})
export const HourglassFilledIcon = makeSpriteIcon('hourglass-filled', {
    viewBox: HourglassFilledSymbol.viewBox
})
export const HourglassIcon = makeSpriteIcon('hourglass', {viewBox: HourglassSymbol.viewBox})
export const LocationFilledIcon = makeSpriteIcon('location-filled', {
    viewBox: LocationFilledSymbol.viewBox
})
export const LocationIcon = makeSpriteIcon('location-leap', {viewBox: LocationSymbol.viewBox})
export const LoginIcon = makeSpriteIcon('login', {viewBox: LoginSymbol.viewBox})
export const LogoutIcon = makeSpriteIcon('logout-leap', {viewBox: LogoutSymbol.viewBox})
export const PauseIcon = makeSpriteIcon('pause', {viewBox: PauseSymbol.viewBox})
export const PenFilledIcon = makeSpriteIcon('pen-filled', {viewBox: PenFilledSymbol.viewBox})
export const PenIcon = makeSpriteIcon('pen', {viewBox: PenSymbol.viewBox})
export const PlayIcon = makeSpriteIcon('play-leap', {viewBox: PlaySymbol.viewBox})
export const RemoveIcon = makeSpriteIcon('remove', {viewBox: RemoveSymbol.viewBox})
export const Rotate360Icon = makeSpriteIcon('rotate360', {viewBox: Rotate360Symbol.viewBox})
export const SearchAddIcon = makeSpriteIcon('search-add', {viewBox: SearchAddSymbol.viewBox})
export const SearchIcon = makeSpriteIcon('search', {viewBox: SearchSymbol.viewBox})
export const SearchMinusIcon = makeSpriteIcon('search-minus', {viewBox: SearchMinusSymbol.viewBox})
export const SecurityValidationFilledIcon = makeSpriteIcon('security-validation-filled', {
    viewBox: SecurityValidationFilledSymbol.viewBox
})
export const SecurityValidationIcon = makeSpriteIcon('security-validation', {
    viewBox: SecurityValidationSymbol.viewBox
})
export const SettingsFilledIcon = makeSpriteIcon('settings-filled', {
    viewBox: SettingsFilledSymbol.viewBox
})
export const SettingsIcon = makeSpriteIcon('settings', {viewBox: SettingsSymbol.viewBox})
export const SortByDownIcon = makeSpriteIcon('sort-by-down', {viewBox: SortByDownSymbol.viewBox})
export const SortByUpIcon = makeSpriteIcon('sort-by-up', {viewBox: SortByUpSymbol.viewBox})
export const StarFilledIcon = makeSpriteIcon('star-filled', {viewBox: StarFilledSymbol.viewBox})
export const StarIcon = makeSpriteIcon('star', {viewBox: StarSymbol.viewBox})
export const StopWatchFilledIcon = makeSpriteIcon('stop-watch-filled', {
    viewBox: StopWatchFilledSymbol.viewBox
})
export const StopWatchIcon = makeSpriteIcon('stop-watch', {viewBox: StopWatchSymbol.viewBox})
export const TokenCircleFilledIcon = makeSpriteIcon('token-circle-filled', {
    viewBox: TokenCircleFilledSymbol.viewBox
})
export const TokenCircleIcon = makeSpriteIcon('token-circle', {viewBox: TokenCircleSymbol.viewBox})
export const TrippTrappIcon = makeSpriteIcon('tripp-trapp', {viewBox: TrippTrappSymbol.viewBox})
export const UserFilledIcon = makeSpriteIcon('user-filled', {viewBox: UserFilledSymbol.viewBox})
export const UserIcon = makeSpriteIcon('user-leap', {viewBox: UserSymbol.viewBox})
export const VideoIcon = makeSpriteIcon('video', {viewBox: VideoSymbol.viewBox})
